module.exports = "/_next/static/images/34872b7e0719ac1230888dea7a6ca4f5-roxinho-details-metalico-md@1x.jpg";